var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCoupon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_coupon_svg__st1",
    d: "M29 13.45c.55 0 1-.45 1-1V4.96c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v7.49c0 .55.45 1 1 1 1.5 0 2.71 1.13 2.71 2.53 0 1.39-1.22 2.53-2.71 2.53-.55 0-1 .45-1 1V27c0 .55.45 1 1 1h26c.55 0 1-.45 1-1v-7.49c0-.55-.45-1-1-1-1.5 0-2.71-1.13-2.71-2.53 0-1.39 1.21-2.53 2.71-2.53zm-1 6.96V26H12.35v-4.31h-2V26H4v-5.6c2.12-.44 3.71-2.26 3.71-4.43S6.12 12 4 11.55v-5.6h6.35v4.28h2V5.96H28v5.6c-2.12.44-3.71 2.26-3.71 4.42s1.59 3.98 3.71 4.43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon_coupon_svg__st1",
    d: "M10.35 16.87h2v3h-2zM10.35 12.06h2v3h-2z"
  }))));
}

export default SvgIconCoupon;